import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/en/Main.vue";
// import { BoardRoutes } from "./board.router";
// import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },

    // AboutUs
    {
        path: "/aboutus/company-profile",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/aboutus/CompanyProfilePage.vue"),
        props: true,
    },
    {
        path: "/aboutus/certificate",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/aboutus/CertificatePage.vue"),
        props: true,
    },
    {
        path: "/aboutus/organization",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/aboutus/OrganizationPage.vue"),
        props: true,
    },
    {
        path: "/aboutus/location/paju",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/aboutus/LocationPajuPage.vue"),
        props: true,
    },
    {
        path: "/aboutus/location/ulsan",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/aboutus/LocationUlsanPage.vue"),
        props: true,
    },
    {
        path: "/aboutus/location/daesan",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/aboutus/LocationDaesanPage.vue"),
        props: true,
    },

    // Project
    {
        path: "/project",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/project/ProjectPage.vue"),
        props: true,
    },

    // Project
    {
        path: "/reference",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/reference/ReferencePage.vue"),
        props: true,
    },

    // alliance
    {
        path: "/alliance",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/alliance/AlliancePage.vue"),
        props: true,
    },

    // product
    {
        path: "/product",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/product/ProductPage.vue"),
        props: true,
    },
    {
        path: "/product/:tab",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/product/ProductPage.vue"),
        props: true,
    },

    // contactus
    {
        path: "/contactus",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/contactus/ContactUsPage.vue"),
        props: true,
    },

    {
        // 국문 메인 페이지
        path: "/ko",
        component: () => import(/* webpackChunkName: "Main" */ "../pages/client/ko/Main.vue"),
        props: true,
    },
    // AboutUs
    {
        path: "/ko/aboutus/company-profile",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/aboutus/CompanyProfilePage.vue"),
        props: true,
    },
    {
        path: "/ko/aboutus/certificate",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/aboutus/CertificatePage.vue"),
        props: true,
    },
    {
        path: "/ko/aboutus/organization",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/aboutus/OrganizationPage.vue"),
        props: true,
    },
    {
        path: "/ko/aboutus/location/paju",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/aboutus/LocationPajuPage.vue"),
        props: true,
    },
    {
        path: "/ko/aboutus/location/ulsan",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/aboutus/LocationUlsanPage.vue"),
        props: true,
    },
    {
        path: "/ko/aboutus/location/daesan",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/aboutus/LocationDaesanPage.vue"),
        props: true,
    },

    // product
    {
        path: "/ko/product/",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductPage.vue"),
        props: true,
    },
    {
        path: "/ko/product/:tab",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/product/ProductPage.vue"),
        props: true,
    },

    // alliance
    {
        path: "/ko/alliance",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/alliance/AlliancePage.vue"),
        props: true,
    },

    // project
    {
        path: "/ko/project",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/project/ProjectPage.vue"),
        props: true,
    },

    // Reference
    {
        path: "/ko/reference",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/reference/ReferencePage.vue"),
        props: true,
    },
    // contactus
    {
        path: "/ko/contactus",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/contactus/ContactUsPage.vue"),
        props: true,
    },

    // Project
    // {
    //     path: "/ko/reference",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/reference/ReferencePage.vue"),
    //     props: true,
    // },

    // {
    //     path: "/common/kcp/cert/request",
    //     component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
    //     props: true,
    // },
    // {
    //     path: "/common/kcp/cert/response",
    //     component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
    //     props: true,
    // },
    // {
    //     // 가이드
    //     path: "/guide",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/Guide.vue"),
    //     props: true,
    // },
    // {
    //     // 로그인
    //     path: "/login",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/ko/login/main.vue"),
    //     props: true,
    // },
    // {
    //     // 비밀번호 찾기
    //     path: "/login/find-password",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/ko/login/find-password.vue"),
    //     props: true,
    // },
    // {
    //     // 아이디 찾기
    //     path: "/login/find-id",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/ko/login/find-id.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입
    //     path: "/join",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/ko/join/main.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/type",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/ko/join/type.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/form",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/ko/join/form.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 완료
    //     path: "/join/complete",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/ko/join/complete.vue"),
    //     props: true,
    // },
    // {
    //     // 응찰/낙찰 내역
    //     path: "/mypage/bids-:type",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/BidsPage.vue"),
    //     props: true,
    // },
    // {
    //     // 응찰/낙찰 내역
    //     path: "/mypage/bids-:type/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/BidsPage.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청내역 상세
    //     path: "/mypage/consignment-list/:_form",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/ConsignmentViewPage.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청내역 목록
    //     path: "/mypage/consignment-list",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/ConsignmentListPage.vue"),
    //     props: true,
    // },
    // {
    //     // 작품문의 상세
    //     path: "/mypage/private-list/:_form",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/PrivateViewPage.vue"),
    //     props: true,
    // },
    // {
    //     // 작품문의 목록
    //     path: "/mypage/private-list",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/PrivateListPage.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청
    //     path: "/mypage/consignment-form",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/ConsignmentFormPage.vue"),
    //     props: true,
    // },
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/ko/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/ko/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // Auction Search 페이지
    //     path: "/auction-search/",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/SearchPage.vue"),
    //     props: true,
    // },
    // {
    //     // Auction Search 페이지
    //     path: "/auction-search/:keyword",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/SearchPage.vue"),
    //     props: true,
    // },
    // {
    //     // Auction Hall 페이지
    //     path: "/auction-halls/:hall",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/AuctionHallPage.vue"),
    //     props: true,
    // },
    // {
    //     // Auction Hall 페이지 - Group
    //     path: "/auction-halls/:hall/groups/:group",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/AuctionHallPage.vue"),
    //     props: true,
    // },
    // {
    //     // Auction Work 페이지
    //     path: "/auction-works/:_work",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/AuctionWorkPage.vue"),
    //     props: true,
    // },
    // {
    //     // Auction - 지난경매
    //     path: "/auction-results",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/AuctionResultsPage.vue"),
    //     props: true,
    // },
    // {
    //     // Auction - 지난경매
    //     path: "/auction-results/:hall",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/auction/AuctionResultsPage.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sales
    //     path: "/products",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/products/PrivateSalesPage.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sales
    //     path: "/products/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/products/PrivateSalesPage.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sales
    //     path: "/en/products",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/products/PrivateSalesPage.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sales
    //     path: "/en/products/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/products/PrivateSalesPage.vue"),
    //     props: true,
    // },
    // {
    //     // resoures
    //     path: "/stories",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/resoures/ResouresPage.vue"),
    //     props: true,
    // },
    // {
    //     // resoures:tab
    //     path: "/stories/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/resoures/ResouresPage.vue"),
    //     props: true,
    // },
    // {
    //     // resoures
    //     path: "/en/stories",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/resoures/ResouresPage.vue"),
    //     props: true,
    // },
    // {
    //     // resoures:tab
    //     path: "/en/stories/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/resoures/ResouresPage.vue"),
    //     props: true,
    // },
    // {
    //     // AboutUs
    //     path: "/aboutus",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/about/AboutUsPage.vue"),
    //     props: true,
    // },
    // {
    //     // AboutUs:tab
    //     path: "/aboutus/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/about/AboutUsPage.vue"),
    //     props: true,
    // },
    // {
    //     // AboutUs
    //     path: "/en/aboutus",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/about/AboutUsPage.vue"),
    //     props: true,
    // },
    // {
    //     // AboutUs:tab
    //     path: "/en/aboutus/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/sub/about/AboutUsPage.vue"),
    //     props: true,
    // },
    // {
    //     // How To Bid - 위탁안내
    //     path: "/how-to/consignment",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/how-to/HowToConsignmentPage.vue"),
    //     props: true,
    // },
    // {
    //     // How To Bid - 응찰안내
    //     path: "/how-to/bid",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/how-to/HowToBidPage.vue"),
    //     props: true,
    // },
    // {
    //     // How To Bid - 응찰안내
    //     path: "/how-to/:tab",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/how-to/HowToBidPage.vue"),
    //     props: true,
    // },
    // {
    //     // How To Bid - FAQ
    //     path: "/center/faqs",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/ko/center/faq.vue"),
    //     props: true,
    // },
    // {
    //     // Service - Collection
    //     path: "/collection",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/service/CollectionPage.vue"),
    //     props: true,
    // },
    // {
    //     // Service - Museum Services
    //     path: "/museum-services",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/service/MuseumServicesPage.vue"),
    //     props: true,
    // },
    // {
    //     // Service - Valuations
    //     path: "/valuations",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/service/ValuationsPage.vue"),
    //     props: true,
    // },
    // {
    //     // About - About & Mission
    //     path: "/about-mission",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/about/AboutMissionPage.vue"),
    //     props: true,
    // },
    // {
    //     // About - 공지사항
    //     path: "/center/notice",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/ko/center/notice.vue"),
    //     props: true,
    // },
    // {
    //     // About - 공지사항
    //     path: "/center/notice/:_notification",
    //     component: () => import(/* webpackChunkName: "center" */ "../pages/client/ko/center/notice.vue"),
    //     props: true,
    // },
    // {
    //     // About - 언론보도
    //     path: "/board/press",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/Press.vue"),
    //     children: [...BoardRoutes],
    //     props: true,
    // },
    // {
    //     // About - 위치안내
    //     path: "/location",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/sub/about/LocationPage.vue"),
    //     props: true,
    // },
    // {
    //     // 캐터옥션 유튜브
    //     path: "/board/youtube",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/Youtube.vue"),
    //     children: [...BoardRoutes],
    //     props: true,
    // },
    // {
    //     // 캐터옥션 리포트
    //     path: "/board/report",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/Report.vue"),
    //     children: [...BoardRoutes],
    //     props: true,
    // },
    // {
    //     // Forms & Archives
    //     path: "/board/forms",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/Forms.vue"),
    //     children: [...BoardRoutes],
    //     props: true,
    // },
    // {
    //     // 경매약관
    //     path: "/auction-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/center/AuctionPolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 서비스이용약관
    //     path: "/service-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/center/ServicePolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 개인정보처리방침
    //     path: "/privacy-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/center/PrivacyPolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 문의 및 제휴
    //     path: "/form/inquiry-partner",
    //     component: () => import(/* webpackChunkName: "form" */ "../pages/client/ko/form/InquiryPartner.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청문의
    //     path: "/form/consignment-sale",
    //     component: () => import(/* webpackChunkName: "form" */ "../pages/client/ko/form/ConsignmentSale.vue"),
    //     props: true,
    // },
    // {
    //     // Private Sale 문의
    //     path: "/form/private-sale",
    //     component: () => import(/* webpackChunkName: "form" */ "../pages/client/ko/form/PrivateSale.vue"),
    //     props: true,
    // },
    // {
    //     // 개인정보처리방침
    //     path: "/about/press",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/board/AuthorBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 데모신청 폼 메일
    //     path: "/demo",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/ko/demo/DemoPage.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 페이지
    //     path: "/resoures/library",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/LibraryBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 뷰페이지
    //     path: "/resoures/library/:id",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/LibraryView.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 커스텀 페이지
    //     path: "/resoures/customer",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/CustomerBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 커스텀 뷰페이지
    //     path: "/resoures/customer/:id",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/CustomerView.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 페이지
    //     path: "/partners",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/PartnersBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 페이지
    //     path: "/about",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/ko/board/AboutBoard.vue"),
    //     props: true,
    // },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 영문 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // {
    //     // 데모신청 폼 메일
    //     path: "/en/demo",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/en/demo/DemoPage.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 페이지
    //     path: "/en/resoures/library",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/board/LibraryBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 뷰페이지
    //     path: "/en/resoures/library/:id",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/board/LibraryView.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 커스텀 페이지
    //     path: "/en/resoures/customer",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/board/CustomerBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 커스텀 뷰페이지
    //     path: "/en/resoures/customer/:id",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/board/CustomerView.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 페이지
    //     path: "/en/partners",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/board/PartnersBoard.vue"),
    //     props: true,
    // },
    // {
    //     // 리소스 라이브러리 페이지
    //     path: "/en/about",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/en/board/AboutBoard.vue"),
    //     props: true,
    // },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/ko/BoardList.vue"),
    },
    {
        // 관리자 - 게시판 타이틀
        path: "/console/boards/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardSettingPage.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/ko/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/ko/BoardView.vue"),
    },
    {
        // 관리자 - 영어 게시판관리
        path: "/console/en/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/en/BoardList.vue"),
    },
    {
        // 관리자 - 영어 게시판관리
        path: "/console/en/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/en/BoardView.vue"),
    },
    {
        // 관리자 - 영어 게시판관리
        path: "/console/en/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/en/BoardView.vue"),
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자 정보
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    // {
    //     // 관리자 - 대시보드
    //     path: "/console/dashboard",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Dashboard.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 옥션 프로그램
    //     path: "/console/auction-programs",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/ProgramListPage.vue"),
    //     props: true,
    //     scope: ["console"],
    // },
    // {
    //     // 관리자 - 옥션 작품
    //     path: "/console/auction-works",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/WorkListPage.vue"),
    //     props: true,
    //     scope: ["console"],
    // },
    // {
    //     // 관리자 - 옥션 작가
    //     path: "/console/auction-authors",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/AuthorListPage.vue"),
    //     props: true,
    //     scope: ["console"],
    // },
    // {
    //     // 관리자 - 폼메일관리
    //     path: "/console/forms",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    // },
    // {
    //     // 관리자 - 폼메일관리
    //     path: "/console/forms/:_form",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    // },
    // {
    //     // 관리자 - 회원등급
    //     path: "/console/users/levels",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 회원등급
    //     path: "/console/users/withdrawals",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 공지사항
    //     path: "/console/center/notifications",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - FAQ
    //     path: "/console/center/faqs",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 1:1문의
    //     path: "/console/center/questions",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
    //     props: true,
    // },

    // {
    //     // 관리자 - 상품관리
    //     path: "/console/shop/products",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 상품 생성
    //     path: "/console/shop/products/create",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 상품 복사
    //     path: "/console/shop/products/copy",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 상품 view
    //     path: "/console/shop/products/:_product",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 카테고리 관리
    //     path: "/console/shop/categories",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/CategoryList.vue"),
    //     props: true,
    // },

    // {
    //     // 관리자 - 서비스 이용약관
    //     path: "/console/terms",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 배너관리
    //     path: "/console/banners",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 배너관리
    //     path: "/console/banners/create",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 배너관리
    //     path: "/console/banners/:_banner",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 팝업관리
    //     path: "/console/popups",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
    //     props: true,
    // },
    // {
    //     // 관리자 - 팝업관리
    //     path: "/console/setting",
    //     component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
    //     props: true,
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = undefined,
            mobileWidth = 1200,
            headerHeight = 60,
            tabHeight = 42;
        if (window.innerWidth > mobileWidth) {
            headerHeight = 115;
            tabHeight = 62;
        }

        if (to.hash) {
            return {
                selector: to.hash,
                offset: { x: 0, y: headerHeight + tabHeight - 4 },
                behavior: "smooth",
            };
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        if (scrollTo != undefined) {
            return {
                selector: scrollTo,
                behavior: "smooth",
            };
        }
    },
});

router.beforeEach((to, from, next) => {
    axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("accessToken") ? `Bearer ${sessionStorage.getItem("accessToken")}` : "";
    axios.defaults.headers.common["Accept-Language"] = i18n.locale;

    next();
});

export default router;
